export const date = {
    labels: {
        date: "Data",
        birthdate: "Nascimento",
        day: "Dia",
        month: "Mês",
        year: "Ano"
    },
    placeholders: {
        date: "DD/MM/YYYY",
    },
    months: {
        full: {
            january: "Janeiro",
            february: "Fevereiro",
            march: "Março",
            april: "Abril",
            may: "Maio",
            june: "Junho",
            july: "Julho",
            august: "Agosto",
            september: "Setembro",
            october: "Outubro",
            november: "Novembro",
            december: "Dezembro",
        },
        short: {
            january: "Jan",
            february: "Fev",
            march: "Mar",
            april: "Abr",
            may: "Mai",
            june: "Jun",
            july: "Jul",
            august: "Ago",
            september: "Set",
            october: "Out",
            november: "Nov",
            december: "Dez",
        },
    },
    texts: {
    },
};
